import { Component } from "@angular/core";
import { NzSelectClearComponent } from "ng-zorro-antd/select";

@Component({
  selector: "ui-select-clear",
  templateUrl: "select-clear.component.html",
})
export class UiSelectClearComponent extends NzSelectClearComponent {}
